import React from 'react'
import './HomePageCard.css'
import { useNavigate } from 'react-router'

function HomePageCard(props) {
    const navigate = useNavigate();

    function handleClick(path) {
        navigate(path);
    }


    return (
        <div className='homePageCard-div' onClick={() => handleClick(props.path)} style={{ height: props.height, width: props.width }}>
            <div className='category-div'>
                <h3 className='category'>{props.category}</h3>
                <h4 className='type'>{props.type}</h4>
            </div>
            <img src={props.img} alt='category' />
        </div>
    )
}

export default HomePageCard